import { Button, Card, Divider, Form, Image, Input, Radio, Select, Typography, Upload, Modal } from "antd";
import { useEffect, useState, useRef } from "react";
import { DeleteOutlined, LeftOutlined, CloseCircleFilled, LinkOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import CustomizeAddProduct from "../../../Modal/CustomizeAddProduct";
import CustomizeCustomProduct from "../../../Modal/CustomizeCustomProduct";
import globalRequest from "../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import * as Apis from "../../../utils/helper/enum";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import config from "../../../config";
import uploadImg from "../../../images/upload-img.png";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const EditOrder = () => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [orderData, setOrderData] = useState([]);
  const [allBranch, setAllBranch] = useState([]);
  const [allPackagingList, setAllPackagingList] = useState([]);

  const [fileList] = useState([]);
  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  // const [previewImage, setPreviewImage] = useState("");
  const [imageIndex, setImageIndex] = useState("");

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <img src={uploadImg} alt="Upload" />
    </button>
  );

  const [formData, setFormData] = useState({
    vendorId: null,
    orderDeliveryType: null,
    branch_id: null,
    order_delivery_type: "",
    order_item_details: [],
    customer_details: {},
  });

  const addMoreProduct = async () => {
    let newObj = {
      type: null,
      product_id: 0,
      uom_id: 0,
      modifier_details: null,
      custom_cake_images: null,
      refference_link: null,
      packaging_type_id: null,
      item_sensitivity_id: null,
      product: null,
      custom_product_price: 0,
    };
    setFormData((prev) => ({
      ...prev,
      order_item_details: [...prev?.order_item_details, newObj],
    }));

    const order_item_details = [...(form.getFieldValue("order_item_details") || []), newObj];

    let branchData = {};
    for (let branch of allBranch) {
      if (orderData?.branchId === branch.value) branchData = branch;
    }
    // Set form fields
    form.setFields([
      {
        name: "vendorId",
        value: orderData?.vendorId,
      },
      {
        name: "branch",
        value: branchData || null,
      },
      {
        name: "orderDeliveryType",
        value: orderData.orderDeliveryType,
      },
      {
        name: "order_item_details",
        value: order_item_details,
      },
      {
        name: ["customer_details", "firstName"],
        value: orderData?.userDetails?.firstName,
      },
      {
        name: ["customer_details", "lastName"],
        value: orderData?.userDetails?.lastName,
      },
      {
        name: ["customer_details", "mobileNo"],
        value: orderData?.userDetails?.mobileNo,
      },
      {
        name: ["customer_details", "email"],
        value: orderData?.userDetails?.email,
      },
    ]);
  };

  const removeObjectFromDetail = async (indexToRemove) => {
    setFormData((prev) => {
      let newObj = {
        ...prev,
        order_item_details: prev.order_item_details.filter((_, index) => index !== indexToRemove),
      };
      form.setFieldsValue({
        ...newObj,
        [`product_${indexToRemove}_type`]: null,
      });
      return newObj;
    });
  };

  const changeProductType = async (index, newType) => {
    // Update the form data in state
    setFormData((prev) => {
      const updatedOrderItemDetails = [...prev.order_item_details];
      if (updatedOrderItemDetails[index]) {
        updatedOrderItemDetails[index].type = newType;
      }
      return {
        ...prev,
        order_item_details: updatedOrderItemDetails,
      };
    });

    // Update the form fields
    const currentOrderItemDetails = [...(form.getFieldValue("order_item_details") || [])];
    if (currentOrderItemDetails[index]) {
      currentOrderItemDetails[index].type = newType;
    }

    form.setFields([
      {
        name: "order_item_details",
        value: currentOrderItemDetails,
      },
    ]);
    openPopUpModel(index, currentOrderItemDetails[index]);
  };

  //Get Order Detail Function
  const getOrderDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.ORDERS.GET_ORDER_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        setOrderData(data);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  //Get Order Detail call on page load
  useEffect(() => {
    if (id) getOrderDetail(id);
  }, []);

  //get all branch list
  const getAllBranches = async (vendorId) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(Apis.ORDERS.GET_ALL_BRANCH_BY_VENDOR + "/" + vendorId, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.name,
          };
        });
        setAllBranch(data || []);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  // Wrapper function to fetch branches when order data is available
  const fetchBranches = async () => {
    if (orderData?.vendorId) {
      await getAllBranches(orderData.vendorId);
    }
  };

  // use when edit form
  useEffect(() => {
    if (orderData) {
      fetchBranches();
    }
  }, [orderData]);

  //set all formData and form values
  useEffect(() => {
    if (orderData) {
      let branchData = {};
      for (let branch of allBranch) {
        if (orderData?.branchId === branch.value) branchData = branch;
      }

      let order_item_details = [];

      if (orderData?.orderDetails) {
        let i = 1;
        for (let order of orderData?.orderDetails) {
          let product = {};
          if (order.type === "product") {
            let pImg = "";
            let modifier_details = [];
            for (let row of order?.orderItemJson?.productUoms[0].productUomImages) {
              if (row?.featured === "1") pImg = row?.image;
            }

            let pName = "";
            for (let row of order?.orderItemJson?.productLocales) {
              if (row?.languageCode === "en") pName = row?.name;
            }

            let uomName = "";
            for (let row of order?.orderItemJson?.productUoms[0]?.productUomLocales) {
              if (row?.languageCode === "en") uomName = row?.name;
            }

            let modiName = [];
            for (let row of order?.orderItemJson?.productModifier) {
              let modifireName = "";
              for (let row1 of row?.modifierGroup?.modifierGroupLocales) {
                if (row1?.languageCode === "en") modifireName = row1?.name;
              }
              let modifireItems = [];
              for (let row1 of row?.productUomModifierItems) {
                if (row1.modifierGroupItem?.modifierGroupItemLocales)
                  for (let row2 of row1?.modifierGroupItem?.modifierGroupItemLocales) {
                    if (row2?.languageCode === "en") modifireItems.push(row2?.name);
                  }
              }
              modiName.push({
                modifireName: modifireName,
                modifireItem: modifireItems.join(", "),
              });

              let modifier_items_data = [];
              for (let row1 of row.productUomModifierItems) {
                modifier_items_data.push({ product_modifier_item_id: row1.id });
              }
              modifier_details.push({
                product_modifier_id: row.id,
                modifier_items: modifier_items_data,
              });
            }

            product = {
              productImg: pImg,
              productName: pName,
              productUomName: uomName,
              modifireName: modiName,
              totalAmount: order.totalAmount,
            };

            order_item_details.push({
              custom_product_price: order?.totalAmount,
              type: order.type,
              product_id: order?.productId,
              uom_id: order?.uomId,
              modifier_details: modifier_details,
              product: product,
            });
          } else {
            let modiName = [];
            let modifier_details = [];
            for (let row of order?.orderItemJson?.modifierGroup) {
              let modifireName = "";
              for (let row1 of row?.modifierGroupLocales) {
                if (row1?.languageCode === "en") modifireName = row1?.name;
              }
              let modifireItems = [];
              for (let row1 of row?.modifierGroupItems) {
                for (let row2 of row1?.modifierGroupItemLocales) {
                  if (row2?.languageCode === "en") modifireItems.push(row2?.name);
                }
              }
              modiName.push({
                modifireName: modifireName,
                modifireItem: modifireItems.join(", "),
              });

              let modifier_items_data = [];
              for (let row1 of row.modifierGroupItems) {
                modifier_items_data.push({ product_modifier_item_id: row1.id });
              }
              modifier_details.push({
                product_modifier_id: row.id,
                modifier_items: modifier_items_data,
              });
            }
            let productImg = [];
            if (order?.orderItemJson?.customCakeImages)
              for (let row of order?.orderItemJson?.customCakeImages) {
                productImg.push({ image: row.image });
              }
            let packageingSize = {};
            if (order?.orderItemJson?.packageingType) {
              packageingSize = {
                value: order?.orderItemJson?.packageingType?.id,
                label: order?.orderItemJson?.packageingType?.name,
              };
            }
            let itemSensitivity = {};
            if (order?.orderItemJson?.itemSensitivity) {
              itemSensitivity = {
                value: order?.orderItemJson?.itemSensitivity?.id,
                label: order?.orderItemJson?.itemSensitivity?.name,
              };
            }

            product = {
              productName: "Custom Product " + i,
              productImages: productImg,
              productUomName: "",
              modifireName: modiName,
              totalAmount: order.totalAmount,
              reference_link: order?.orderItemJson?.reference_link,
              packageingSize: packageingSize,
              itemSensitivity: itemSensitivity,
            };

            order_item_details.push({
              type: order.type,
              product_id: 0,
              uom_id: 0,
              custom_product_price: order?.totalAmount,
              modifier_details: modifier_details,
              custom_cake_images: productImg,
              refference_link: order?.orderItemJson?.reference_link,
              packaging_type_id: packageingSize,
              item_sensitivity_id: itemSensitivity,
              product: product,
            });

            i++;
          }

          // order_item_details.push({
          //   id: order.id,
          //   orderId: order?.orderId,
          //   product_id:order?.product_id,
          //   uom_id:order?.uom_id,
          //   type: order.type,
          //   product: product
          // });
        }
      }

      //set in form data
      setFormData({
        vendorId: orderData.vendorId || null,
        branch: branchData || null,
        orderDeliveryType: orderData.orderDeliveryType,
        order_item_details: order_item_details,
        customer_details: {
          firstName: orderData?.userDetails?.firstName,
          lastName: orderData?.userDetails?.lastName,
          mobileNo: orderData?.userDetails?.mobileNo,
          email: orderData?.userDetails?.email,
        },
      });

      //set in form Value
      const formValues = {
        vendorId: orderData?.vendorId, // Setting vendor ID
        branch: branchData || null,
        orderDeliveryType: orderData.orderDeliveryType,
        order_item_details: order_item_details,
        customer_details: {
          firstName: orderData?.userDetails?.firstName,
          lastName: orderData?.userDetails?.lastName,
          mobileNo: orderData?.userDetails?.mobileNo,
          email: orderData?.userDetails?.email,
        },
      };

      form.setFieldsValue(formValues);
    }
  }, [allBranch]);

  //get all packaging list
  const getAllPackagingList = async (vendorId) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(Apis.ORDERS.GET_ALL_PACKAGING_LIST, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.name,
          };
        });
        setAllPackagingList(data || []);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };
  useEffect(() => {
    getAllPackagingList();
  }, []);

  // Dynamically set form values when formData changes
  useEffect(() => {
    if (formData?.customer_details) {
      form.setFieldsValue({
        firstName: formData.customer_details.firstName,
        lastName: formData.customer_details.lastName,
        email: formData.customer_details.email,
        mobileNo: formData.customer_details.mobileNo,
      });
    }
  }, [formData]);

  const handleSubmit = async (values) => {
    let order_item_details = [];
    for (let detail of formData.order_item_details) {
      if (detail?.type === "product") {
        order_item_details.push({
          custom_product_price: detail?.custom_product_price,
          type: detail?.type,
          product_id: detail?.product_id,
          uom_id: detail?.uom_id,
          modifier_details: detail?.modifier_details,
        });
      } else {
        order_item_details.push({
          custom_product_price: detail?.custom_product_price,
          type: detail?.type,
          modifier_details: detail?.modifier_details,
          custom_cake_images: detail?.custom_cake_images,
          reference_link: detail?.refference_link,
          packaging_type_id: detail?.packaging_type_id?.value,
        });
      }
    }

    let insertData = {
      branch_id: formData?.branch.value,
      order_delivery_type: formData?.orderDeliveryType,
      order_item_details: order_item_details,
      customer_details: {
        firstName: values.firstName,
        lastName: values.lastName,
        mobileNo: values.mobileNo,
        email: values.email,
      },
    };

    dispatch(changeLoader(true));
    try {
      // console.log(insertData); return false;
      let url = Apis?.ORDERS?.EDIT_ORDER + "/" + id;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Order created successfully";
        if (id) msg = "Order updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/order-management");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const [isCustomizeAddProductModalOpen, setIsCustomizeAddProductModalOpen] = useState({});
  const [isCustomizeCustomProductModalOpen, setIsCustomizeCustomProductModalOpen] = useState({});

  const openPopUpModel = (index, item) => {
    if (item.type === "product") {
      setIsCustomizeAddProductModalOpen({
        isOpen: true,
        index: index,
        item: item,
      });
    } else {
      setIsCustomizeCustomProductModalOpen({
        isOpen: true,
        index: index,
        item: item,
      });
    }
  };

  const handleCustomizeAddProductOk = (itemdata) => {
    let index = isCustomizeAddProductModalOpen.index;
    let newObj = {
      type: itemdata.type,
      product_id: itemdata.product_id,
      uom_id: itemdata.uom_id,
      modifier_details: itemdata.modifier_details,
      custom_cake_images: null,
      refference_link: null,
      packaging_type_id: null,
      product: itemdata.product,
    };
    setFormData((prev) => {
      const updatedOrderItemDetails = [...prev.order_item_details]; // Clone the existing array
      updatedOrderItemDetails[index] = {
        ...updatedOrderItemDetails[index],
        ...newObj,
      }; // Update the object at the specified index
      return { ...prev, order_item_details: updatedOrderItemDetails }; // Update formData with the modified array
    });

    // Update the form field if needed
    const order_item_details = [...(form.getFieldValue("order_item_details") || [])];
    order_item_details[index] = { ...order_item_details[index], ...newObj };

    form.setFields([
      {
        name: "order_item_details",
        value: order_item_details,
      },
    ]);

    setIsCustomizeAddProductModalOpen({
      isOpen: false,
      index: null,
    });
  };

  const handleCustomizeCustomProductOk = (newObj) => {
    let index = isCustomizeCustomProductModalOpen.index;

    setFormData((prev) => {
      const updatedOrderItemDetails = [...prev.order_item_details]; // Clone the existing array
      updatedOrderItemDetails[index] = {
        ...updatedOrderItemDetails[index],
        ...newObj,
      }; // Update the object at the specified index
      return { ...prev, order_item_details: updatedOrderItemDetails }; // Update formData with the modified array
    });

    // Update the form field if needed
    const order_item_details = [...(form.getFieldValue("order_item_details") || [])];
    order_item_details[index] = { ...order_item_details[index], ...newObj };

    form.setFields([
      {
        name: "order_item_details",
        value: order_item_details,
      },
    ]);

    setIsCustomizeCustomProductModalOpen({
      isOpen: false,
      index: null,
    });
  };

  const handleReferenceLinkBlur = (value, index) => {
    setFormData((prev) => {
      const updatedOrderItemDetails = [...prev.order_item_details]; // Clone the existing array
      updatedOrderItemDetails[index] = {
        ...updatedOrderItemDetails[index],
        refference_link: value,
        product: {
          ...updatedOrderItemDetails[index]?.product,
          reference_link: value,
        },
      };
      return { ...prev, order_item_details: updatedOrderItemDetails }; // Return the updated formData
    });

    // Update the form field
    const order_item_details = [...(form.getFieldValue("order_item_details") || [])];
    order_item_details[index] = {
      ...order_item_details[index],
      refference_link: value, // Update only the reference_link field
      product: { ...order_item_details[index]?.product, reference_link: value },
    };

    form.setFields([
      {
        name: "order_item_details",
        value: order_item_details, // Set the updated order_item_details array in the form
      },
    ]);
  };

  const handlePackagingType = (value, index) => {
    let itemValue = {};
    for (let row of allPackagingList) {
      if (row.value === value)
        itemValue = {
          value: row?.value,
          label: row?.label,
        };
    }
    setFormData((prev) => {
      const updatedOrderItemDetails = [...prev.order_item_details]; // Clone the existing array
      updatedOrderItemDetails[index] = {
        ...updatedOrderItemDetails[index],
        packaging_type_id: itemValue,
        product: {
          ...updatedOrderItemDetails[index]?.product,
          packageingSize: itemValue,
        },
      };
      return { ...prev, order_item_details: updatedOrderItemDetails }; // Return the updated formData
    });

    // Update the form field
    const order_item_details = [...(form.getFieldValue("order_item_details") || [])];
    order_item_details[index] = {
      ...order_item_details[index],
      packaging_type_id: itemValue, // Update only the reference_link field
      product: {
        ...order_item_details[index]?.product,
        packageingSize: itemValue,
      },
    };

    form.setFields([
      {
        name: "order_item_details",
        value: order_item_details, // Set the updated order_item_details array in the form
      },
    ]);
  };

  const handleCustomizeAddProductCancel = () => {
    let index = isCustomizeAddProductModalOpen.index;
    setFormData((prev) => {
      form.setFieldsValue({
        ...prev,
        [`product_${index}_type`]: null,
      });
      return prev;
    });

    setIsCustomizeAddProductModalOpen({
      isOpen: false,
      index: null,
    });
  };

  const handleCustomizeCustomProductCancel = () => {
    let index = isCustomizeCustomProductModalOpen.index;
    setFormData((prev) => {
      form.setFieldsValue({
        ...prev,
        [`product_${index}_type`]: null,
      });
      return prev;
    });
    setIsCustomizeCustomProductModalOpen({
      isOpen: false,
      index: null,
    });
  };

  const handleUpload = ({ file }, index) => {
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > maxSize) {
      // Show an error message or notification
      toast.error("File size must be less than 5 MB.");
      return false; // Prevent adding the file to the file list
    }

    if (file.status === "removed") return false;
    // setImageData({ imagename: file.name, imagetype: file.type });
    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setPreviewOpen(true);
    setImageIndex(index);

    form.setFields([
      {
        name: `product_${index}_reference_link`,
        errors: [], // Remove validation if images exist
      },
    ]);

    return false; // Prevent automatic upload
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 500, // Reduce width (Adjust as needed)
        height: 500, // Reduce height
      });
      const croppedImage = canvas.toDataURL("image/jpeg", 0.7); // Lower quality to 70%
      uploadImage(croppedImage);
    }
  };

  const uploadImage = async (file) => {
    let insertData = {
      files: file,
      title_en: "",
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.ORDERS?.ADD_CUSTOME_CAKE_IMAGE;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let path = apiResponse?.data[0].path;

        let index = imageIndex;
        let image = { image: path }; // The new image object

        // Update the state
        setFormData((prev) => {
          const updatedOrderItemDetails = [...prev.order_item_details]; // Clone the existing array

          // Clone and update the custom_cake_images array
          const updatedCustomCakeImages = [...(updatedOrderItemDetails[index]?.custom_cake_images || []), image];

          updatedOrderItemDetails[index] = {
            ...updatedOrderItemDetails[index],
            custom_cake_images: updatedCustomCakeImages, // Update the array
            product: {
              ...updatedOrderItemDetails[index]?.product,
              custom_cake_images: updatedCustomCakeImages, // Reflect the change in product as well
            },
          };

          return { ...prev, order_item_details: updatedOrderItemDetails }; // Return updated state
        });

        // Update the form field
        const order_item_details = [...(form.getFieldValue("order_item_details") || [])];

        // Clone and update the custom_cake_images array in the form
        const updatedCustomCakeImages = [...(order_item_details[index]?.custom_cake_images || []), image];

        order_item_details[index] = {
          ...order_item_details[index],
          custom_cake_images: updatedCustomCakeImages, // Update the array
          product: {
            ...order_item_details[index]?.product,
            custom_cake_images: updatedCustomCakeImages, // Reflect the change in product as well
          },
        };

        // Set the updated values in the form
        form.setFields([
          {
            name: "order_item_details",
            value: order_item_details, // Set the updated order_item_details array in the form
          },
        ]);

        setPreviewOpen(false);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const handleRemove = (index, ind) => {
    // Remove image from the state
    setFormData((prev) => {
      const updatedOrderItemDetails = [...prev.order_item_details]; // Clone the existing array

      // Clone and remove the image at the given index in the custom_cake_images array
      const updatedCustomCakeImages = [...(updatedOrderItemDetails[index]?.custom_cake_images || [])];
      updatedCustomCakeImages.splice(ind, 1); // Remove the image at the given index

      updatedOrderItemDetails[index] = {
        ...updatedOrderItemDetails[index],
        custom_cake_images: updatedCustomCakeImages, // Update the array
        product: {
          ...updatedOrderItemDetails[index]?.product,
          custom_cake_images: updatedCustomCakeImages, // Reflect the change in product as well
        },
      };

      return { ...prev, order_item_details: updatedOrderItemDetails }; // Return updated state
    });

    // Remove image from the form field
    const order_item_details = [...(form.getFieldValue("order_item_details") || [])];

    // Clone and remove the image at the given index in the custom_cake_images array in the form
    const updatedCustomCakeImages = [...(order_item_details[index]?.custom_cake_images || [])];
    updatedCustomCakeImages.splice(ind, 1); // Remove the image at the given index

    order_item_details[index] = {
      ...order_item_details[index],
      custom_cake_images: updatedCustomCakeImages, // Update the array
      product: {
        ...order_item_details[index]?.product,
        custom_cake_images: updatedCustomCakeImages, // Reflect the change in product as well
      },
    };

    // Set the updated values in the form
    form.setFields([
      {
        name: "order_item_details",
        value: order_item_details, // Set the updated order_item_details array in the form
      },
    ]);

    if (updatedCustomCakeImages.length === 0)
      form.setFields([
        {
          name: `product_${index}_reference_link`,
          errors: ["Required"], // Remove validation if images exist
        },
      ]);
  };

  return (
    <>
      <Card>
        <div className="mb-4">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
            Edit Order
          </Typography>
          <p className="w-full max-w-[900px]">
            Initiate the process to place a new order by choosing the type of order. Next, add items/products. Finally, provide your
            customer information to complete the order.
          </p>
        </div>
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            layout="vertical"
            className="flex flex-col gap-5"
            form={form}
            onFinish={(e) => {
              handleSubmit(e);
            }}
            autoComplete="off"
          >
            <div className="tab-1">
              <Card>
                <Typography className="text-base font-semibold" align={"left"}>
                  Order Detail
                </Typography>
                <div className="my-4">
                  <Form.Item
                    label="Select Branch"
                    name="branch"
                    rules={[
                      {
                        required: true,
                        message: "Please select your branch",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      placeholder="Select"
                      options={allBranch}
                      showSearch
                      filterOption={(input, allBranch) => (allBranch?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                      value={formData.branch} // Bind current value from formData
                      onChange={(value) => {
                        // Update formData when vendor changes
                        setFormData((prevData) => ({
                          ...prevData,
                          branch_id: value, // Set the selected vendor ID in formData
                        }));
                      }}
                    />
                  </Form.Item>
                  <Typography className="text-base font-semibold" align={"left"}>
                    Order Type
                  </Typography>
                  <Form.Item
                    name="orderDeliveryType"
                    rules={[
                      {
                        required: true,
                        message: "Please select an Order Type",
                      },
                    ]}
                  >
                    <Radio.Group
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          orderDeliveryType: e.target.value, // Update formData when radio changes
                        }));
                      }}
                    >
                      <div className="grid grid-cols-2 gap-5 mt-4">
                        <div
                          className={`border ${
                            formData.orderDeliveryType === "qc-delivery-payment" ? "border-[#176B53]" : "border-[#E5E7EB]"
                          } p-5 rounded-lg`}
                        >
                          <Radio value="qc-delivery-payment" className="text-sm font-semibold">
                            QC, Delivery & Payment
                            <p className="text-[#808080]">
                              Product undergoes quality check, is delivered to the customer, and payment is collected online upon order
                              approval.
                            </p>
                          </Radio>
                        </div>

                        <div
                          className={`border ${
                            formData.orderDeliveryType === "delivery-payment" ? "border-[#176B53]" : "border-[#E5E7EB]"
                          } p-5 rounded-lg`}
                        >
                          <Radio value="delivery-payment" className="text-sm font-semibold">
                            Delivery & Payment
                            <p className="text-[#808080]">
                              Product undergoes quality check for packaging & delivered to the customer and payment is collected online upon
                              order approval.
                            </p>
                          </Radio>
                        </div>

                        <div
                          className={`border ${
                            formData.orderDeliveryType === "qc-payment" ? "border-[#176B53]" : "border-[#E5E7EB]"
                          } p-5 rounded-lg`}
                        >
                          <Radio value="qc-payment" className="text-sm font-semibold">
                            QC & Payment
                            <p className="text-[#808080]">
                              Product undergoes quality check and payment is collected online upon customer order approval.
                            </p>
                          </Radio>
                        </div>

                        <div
                          className={`border ${
                            formData.orderDeliveryType === "qc" ? "border-[#176B53]" : "border-[#E5E7EB]"
                          } p-5 rounded-lg`}
                        >
                          <Radio value="qc" className="text-sm font-semibold">
                            QC
                            <p className="text-[#808080]">Quality check is performed to ensure product standards.</p>
                          </Radio>
                        </div>
                      </div>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </Card>
            </div>

            <div className="tab-2 flex flex-col gap-5">
              {formData?.order_item_details?.map((item, index) => {
                return (
                  <Card key={index}>
                    <Typography className="text-lg font-semibold mb-3" align={"left"}>
                      Add Product {index + 1}
                    </Typography>
                    <Typography className="text-base font-semibold" align={"left"}>
                      Select Product From
                    </Typography>
                    <Form.Item
                      key={index}
                      label={`Product ${index + 1} Type`}
                      name={`product_${index}_type`}
                      initialValue={item.type}
                      rules={[
                        {
                          required: true,
                          message: "Please select a product type",
                        },
                      ]}
                    >
                      <Radio.Group
                        className="flex gap-5 mt-4"
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            selectedProductType: e.target.value, // Update the selected product type in formData
                          }));
                          changeProductType(index, e.target.value);
                        }}
                        disabled={item.modifier_details} // Disable if item.modifire is null
                      >
                        <div className="border border-[#E5E7EB] p-5 rounded-lg">
                          <Radio value={"product"} className="text-sm font-semibold">
                            Product from Menu
                          </Radio>
                        </div>
                        <div className="border border-[#E5E7EB] p-5 rounded-lg">
                          <Radio value={"custom"} className="text-sm font-semibold">
                            Custom Product
                          </Radio>
                        </div>
                      </Radio.Group>
                    </Form.Item>

                    {item?.type ? (
                      item?.type === "product" ? (
                        item?.product_id > 0 ? (
                          <div className="flex justify-between">
                            <div className="flex gap-3 mt-5">
                              <Image src={config.AWS_URL + item?.product?.productImg} width={40} height={40} />
                              <div className="relative">
                                <h6 className="font-semibold">
                                  {item?.product?.productName} {item?.product?.productUomName ? `(${item?.product?.productUomName})` : ""}
                                </h6>
                                {item?.product?.modifireName?.map((itm, index) => {
                                  return (
                                    <p key={index} className="text-[#808080] whitespace-nowrap text-ellipsis overflow-hidden max-w-[200px]">
                                      {itm?.modifireName} : {itm?.modifireItem}
                                    </p>
                                  );
                                })}
                                <p
                                  className="text-[#808080] underline cursor-pointer"
                                  onClick={() => {
                                    // setIsCustomizeAddProductModalOpen(true);
                                    openPopUpModel(index, item);
                                  }}
                                >
                                  Customize
                                </p>
                              </div>
                            </div>
                            <span className="font-medium">SAR {item?.product?.totalAmount}</span>
                          </div>
                        ) : null
                      ) : (
                        <>
                          <div className="flex justify-between mt-5">
                            <div className="relative">
                              <h6 className="font-semibold">{item?.product?.productName}</h6>
                              {item?.product?.modifireName?.map((itm, index) => {
                                return (
                                  <p key={index} className="text-[#808080] whitespace-nowrap text-ellipsis overflow-hidden max-w-[200px]">
                                    {itm?.modifireName} : {itm?.modifireItem}
                                  </p>
                                );
                              })}
                              {item?.product?.modifireName ? (
                                <p
                                  className="text-[#808080] underline cursor-pointer"
                                  onClick={() => {
                                    // setIsCustomizeAddProductModalOpen(true);
                                    openPopUpModel(index, item);
                                  }}
                                >
                                  Customize
                                </p>
                              ) : null}
                            </div>
                            <span className="font-medium">{item?.product?.totalAmount ? `SAR ${item?.product?.totalAmount}` : null}</span>
                          </div>
                          <Divider className="bg-[#E5E7EB]" />
                          <div className="relative">
                            <h6 className="font-semibold">
                              What kind of product would you like it to resemble? <span className="text-[#ff4d4f]">*</span>
                            </h6>
                            <p className="text-[#808080] w-full max-w-[750px]">
                              Here, you can upload a product image that matches or meets the customer's requirements. At Least one image
                              mandatory, Supports JPEG, PNG, JPG only, max file size 5 MB & max 5 images can be uploaded
                            </p>
                          </div>
                          <div className="flex gap-5 my-4 h-[102px]">
                            <Upload
                              listType="picture-card"
                              fileList={fileList}
                              beforeUpload={() => false}
                              onChange={(e) => {
                                handleUpload(e, index);
                              }}
                              // onRemove={handleRemove()}
                              showUploadList={{ showPreviewIcon: false }}
                            >
                              {fileList.length >= 1 ? null : uploadButton}
                            </Upload>
                            {item?.custom_cake_images?.map((itm, ind) => {
                              return (
                                <div className="relative" key={ind}>
                                  <img src={config.AWS_URL + itm.image} alt="cake2" className="w-[100px] h-[100px] " />
                                  <div className="absolute top-0 p-2 right-0">
                                    <CloseCircleFilled
                                      className="text-[#BA1A1A] text-[18px] cursor-pointer"
                                      onClick={() => {
                                        handleRemove(index, ind);
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          <div className="relative">
                            <h6 className="font-medium mb-2">Or paste a reference link for your custom product</h6>
                            {/* here */}
                            <Form.Item
                              label="Paste a reference link"
                              name={`product_${index}_reference_link`}
                              initialValue={item?.product?.reference_link}
                              rules={[
                                {
                                  required: !item?.custom_cake_images?.length,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Input
                                prefix={<LinkOutlined />}
                                size="large"
                                onBlur={(e) => handleReferenceLinkBlur(e.target.value, index)}
                              />
                            </Form.Item>
                          </div>
                          <Divider className="bg-[#E5E7EB]" />
                          <div className="relative">
                            <h6 className="font-semibold">Other Info</h6>
                            <p className="text-[#808080]">
                              You have selected a custom product with delivery, so please choose the packaging type.
                            </p>
                          </div>
                          <div className="grid grid-cols-2 gap-5 mt-4">
                            <Form.Item
                              label="Package Size"
                              // name="packageingSize"
                              name={`product_${index}_packageingSize`}
                              initialValue={item?.product?.packageingSize}
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Select
                                size="large"
                                placeholder="Select"
                                options={allPackagingList}
                                showSearch
                                filterOption={(input, allPackagingList) =>
                                  (allPackagingList?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                }
                                value={formData.order_item_details[index].packaging_type_id}
                                onChange={(value) => {
                                  // Update formData when vendor changes
                                  handlePackagingType(value, index);
                                }}
                              />
                            </Form.Item>
                          </div>
                        </>
                      )
                    ) : null}

                    {index !== 0 ? (
                      <div
                        className="text-red-100 cursor-pointer font-semibold underline mt-5"
                        onClick={() => {
                          removeObjectFromDetail(index);
                        }}
                      >
                        <DeleteOutlined className="mx-1.5 cursor-pointer" />
                        <span>Delete</span>
                      </div>
                    ) : null}
                  </Card>
                );
              })}
              <div className="mt-6">
                <Button
                  type="primary"
                  className="h-[39px]"
                  onClick={() => {
                    addMoreProduct();
                  }}
                >
                  Add more product
                </Button>
              </div>
            </div>

            <div className="tab-3">
              <Card>
                <div className="my-4">
                  <Typography className="text-base font-semibold" align={"left"}>
                    Customer Info
                  </Typography>
                  <div className="grid grid-cols-2 gap-x-5 mt-4">
                    <Form.Item
                      label="First Name"
                      name="firstName"
                      initialValue={formData?.customer_details?.firstName}
                      rules={[
                        {
                          required: true,
                          message: "First name is required",
                        },
                      ]}
                    >
                      <Input size="large" />
                    </Form.Item>
                    <Form.Item
                      label="Last Name"
                      name="lastName"
                      initialValue={formData?.customer_details?.lastName}
                      rules={[
                        {
                          required: true,
                          message: "Last name is required",
                        },
                      ]}
                    >
                      <Input size="large" />
                    </Form.Item>
                    <Form.Item
                      label="Email"
                      name="email"
                      initialValue={formData?.customer_details?.email}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Email is required",
                      //   },
                      // ]}
                    >
                      <Input size="large" />
                    </Form.Item>
                    <Form.Item
                      label="Mobile"
                      name="mobileNo"
                      initialValue={formData?.customer_details?.mobileNo}
                      rules={[
                        {
                          required: true,
                          message: "Please enter your Mobile",
                        },
                        {
                          min: 9,
                          message: "Mobile number must be 9 digits",
                        },
                        {
                          max: 9,
                          message: "Mobile number must be no more than 9 digits",
                        },
                      ]}
                    >
                      <Input size="large" placeholder="Mobile no" addonBefore={<span>+966</span>} />
                    </Form.Item>
                  </div>
                </div>
              </Card>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <Button className="h-[39px]" onClick={() => navigate("/order-management")}>
                Cancel
              </Button>
              <Button className="h-[39px]" type="primary" htmlType="submit">
                Save
              </Button>
            </div>
          </Form>
        </div>
      </Card>
      {isCustomizeAddProductModalOpen.isOpen ? (
        <CustomizeAddProduct
          isOpen={isCustomizeAddProductModalOpen.isOpen}
          onOk={handleCustomizeAddProductOk}
          onCancel={handleCustomizeAddProductCancel}
          itemData={isCustomizeAddProductModalOpen.item ? isCustomizeAddProductModalOpen.item : {}}
          vendorId={orderData.vendorId}
        />
      ) : null}
      {isCustomizeCustomProductModalOpen.isOpen ? (
        <CustomizeCustomProduct
          isOpen={isCustomizeCustomProductModalOpen}
          onOk={handleCustomizeCustomProductOk}
          onCancel={handleCustomizeCustomProductCancel}
          itemData={isCustomizeCustomProductModalOpen.item ? isCustomizeCustomProductModalOpen.item : {}}
          vendorId={orderData.vendorId}
        />
      ) : null}

      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleCrop}>
            Crop and Upload
          </Button>,
        ]}
      >
        <Cropper src={image} style={{ height: 400, width: "100%" }} aspectRatio={1} guides={false} ref={cropperRef} />
      </Modal>
    </>
  );
};

export default EditOrder;
